import { useState, useEffect } from 'react';

const useRatePulseDateRange = () => {
    const [date, setDate] = useState({
        fromDate: new Date(),
        toDate: new Date()
    });

    useEffect(() => {
        const dateRange = JSON.parse(window.localStorage.getItem('rateshopperDateRange'));
        if (dateRange) {
            setDate({
                fromDate: new Date(dateRange.fromDate),
                toDate: new Date(dateRange.toDate)
            });
        }
    }, []);

    return date;
};

export default useRatePulseDateRange;
